import React, { useState, useEffect } from "react";
import { TextField, Box, Modal, Grid, Tab, Tabs, Button } from "@mui/material";
import { FormError } from "./FormError";
import { enqueueSnackbar } from "notistack";
import { RollingTextLoading } from "./RollingTextLoading";
import { verification, submit_verification } from "../api/api";
import { useNavigate } from 'react-router-dom'


export interface verifyModalProps {
    verify: boolean;
    closeModal: Function;
    token: string;
    login: Object;
    selectedInterest: string;
    zipcode: string;
    selectedProvider: string;
}
const VerifyModal: React.FC<verifyModalProps> = ({
    verify,
    closeModal,
    token,
    login,
    selectedInterest,
    zipcode,
    selectedProvider
}) => {
    const [submitting, setSubmitting] = useState(false);
    const [phoneCodeError, setPhoneCodeError] = useState(false);
    const [phoneCode, setPhoneCode] = useState("");
    const [mailCodeError, setMailCodeError] = useState(false);
    const [mailCode, setMailCode] = useState("");
    const [tipsModal, setTipsModal] = useState(false);
    const [isApiSucces, setIsApiSucces] = useState(true);
    const [verifyChoose, setVerifyChoose] = useState<string>('sms');
    const [onceSelect, setOnceSelect] = useState('');
    const [seconds, setSeconds] = useState(0);
    const [isRunning, setIsRunning] = useState(false);
    const [responseObject, setresponseObject] = useState({});
    const navigate = useNavigate();

    const chooseChangeHandel = (event: any, newValue: any) => {
        setVerifyChoose(newValue);
        if (onceSelect && onceSelect !== newValue) {
            enqueueSnackbar(
                `A verification code has been sent to your ${onceSelect === 'sms' ? 'phone' : 'email'}. Please check your ${onceSelect === 'sms' ? 'phone messages' : 'email'} for the code.`,
                { variant: "error" }
            );
        }
    };

    useEffect(() => {
        let intervalId: NodeJS.Timeout | null = null;
        if (isRunning) {
            intervalId = setInterval(() => {
                setSeconds(prevSeconds => prevSeconds - 1);
            }, 1000);
        }

        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [isRunning]);

    useEffect(() => {
        if (seconds === 0) {
            setIsRunning(false);
        }
    }, [seconds]);

    const getCode = (method: string) => {
        if (isRunning) return;
        setSeconds(60);
        setIsRunning(true);
        verification(token, method).then((res) => {
            if (res.status === 1) {
                enqueueSnackbar(
                    method === 'sms' ? "The verification code has been sent to your phone" :
                        "The verification code has been sent to your email",
                    { variant: "success" }
                );
                setOnceSelect(method);
            } else if (res.status === -2) {
                enqueueSnackbar(res.msg, { variant: "error" });
            } else {
                setIsApiSucces(false);
                closeHandle(false);
                enqueueSnackbar(
                    "The verification code submission failed. Please try again.",
                    { variant: "error" }
                );
            }
        }).catch(rejected => {
            console.log(rejected);
        });
    };

    const onSubmit = (method: string) => {
        if (submitting) return;
        setSubmitting(true);
        let code = '';
        if (method === 'sms') {
            if (phoneCode) {
                code = phoneCode;
            } else {
                setSubmitting(false);
                setPhoneCodeError(true);
                return;
            }
        } else {
            if (mailCode) {
                code = mailCode;
            } else {
                setSubmitting(false);
                setMailCodeError(true);
                return;
            }
        }
        submit_verification(token, method, code).then((res) => {
            setSubmitting(false);
            if (res.status === 1) {
                console.log(res);
                setresponseObject({...login,...res.response})
                goUserCenter({...login,...res.response});
                // setTimeout(() => {
                //     goUserCenter({...login,...res.response});
                // }, 1500);
                // setTipsModal(true);
            } else if (res.status === -1) {
                enqueueSnackbar(
                    "The verification code submission failed. Please try again.",
                    { variant: "error" }
                );
            } else if (res.status === -2) {
                setIsApiSucces(false);
                enqueueSnackbar(
                    "The account data synchronization submission failed. Please close the dialog and try submitting again.",
                    { variant: "error" }
                );
            }
        }).catch(rejected => {
            setSubmitting(false);
            console.log(rejected);
        });
    };
    const goUserCenter = (res?:any) => {

        localStorage.setItem('ez_switch', JSON.stringify(res ? res : responseObject));
        navigate(`/detail?type=${selectedInterest}&zipcode=${zipcode}&provider=${selectedProvider}`)
    };

    const closeHandle = (b?: boolean) => {
        closeModal(b === false ? b : isApiSucces);
        if (b === false || isApiSucces === false) {
            setSeconds(0);
        }
        setIsApiSucces(true);
        setOnceSelect('');
    };

    return (
        <>
            <Modal open={verify} onClose={() => { closeHandle() }}>
                <Box className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-lg rounded-lg p-2 w-full max-w-lg">
                    <Grid container className="flex justify-between mt-1 mb-2">
                        <h2 className="text-xl font-semibold text-gray-700">My Security</h2>
                        <button
                            className="inline-block w-8 h-8 mask bg-[url('../public/images/X.svg')] bg-no-repeat bg-center border-none cursor-pointer"
                            onClick={() => { closeHandle() }}
                        />
                    </Grid>
                    <div className="container mx-auto p-6">
                        <p className="text-slate-500 leading-7 mb-2">
                            If your customer account has two-step verification, you can choose any of the following methods to verify your account.
                        </p>

                        <Box className="bg-[#e5eeff]">
                            <Tabs
                                value={verifyChoose}
                                variant="fullWidth"
                                indicatorColor="primary"
                                textColor="primary"
                                onChange={chooseChangeHandel}
                                aria-label="tabs example"
                            >
                                <Tab label="mobile phone" value='sms' />
                                <Tab label="E-mail" value='email' />
                            </Tabs>
                        </Box>
                        {verifyChoose === 'sms' ? (
                            <div>
                                <div className="mt-4">Two-Step Verification</div>
                                <div className="w-full max-w-lg flex">
                                    <input
                                        className="flex-1 bg-transparent border-b border-black py-4 px-2"
                                        id="mobilePhone"
                                        name="mobilePhone"
                                        placeholder="Enter cell phone verification code..."
                                        type="text"
                                        value={phoneCode}
                                        onChange={(evt) => {
                                            if (evt.target.value) {
                                                setPhoneCodeError(false);
                                            }
                                            setPhoneCode(evt.target.value);
                                        }}
                                        disabled={submitting}
                                        maxLength={30}
                                    />
                                    <Button
                                        variant="contained"
                                        className={`${isRunning ? '' : 'bg-blue-600'} text-white rounded w-40`}
                                        disabled={isRunning}
                                        onClick={() => { getCode('sms') }}
                                    >
                                        {isRunning ? seconds : 'Get phone code'}
                                    </Button>
                                </div>
                                {phoneCodeError && <FormError message="Please enter your phone verification code" />}
                                <div className="flex justify-center h-10 mt-8 mb-4">
                                    <Button
                                        variant="contained"
                                        onClick={() => { onSubmit('sms') }}
                                        className={`${submitting ? '' : 'bg-blue-600'} text-white rounded w-full max-w-xs`}
                                        disabled={submitting}
                                    >
                                        submit
                                    </Button>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <div className="mt-4">Two-Step Verification</div>
                                <div className="w-full max-w-lg flex">
                                    <input
                                        id="emailVerification"
                                        name="emailVerification"
                                        placeholder="Enter the email verification code..."
                                        type="text"
                                        className="flex-1 bg-transparent border-b border-black py-4 px-2"
                                        value={mailCode}
                                        onChange={(evt) => {
                                            if (evt.target.value) {
                                                setMailCodeError(false);
                                            }
                                            setMailCode(evt.target.value);
                                        }}
                                        disabled={submitting}
                                        maxLength={30}
                                    />
                                    <Button
                                        variant="contained"
                                        className={`${isRunning ? '' : 'bg-blue-600'} text-white rounded w-40`}
                                        disabled={isRunning}
                                        onClick={() => { getCode('email') }}
                                    >
                                        {isRunning ? seconds : 'Get Email code'}
                                    </Button>
                                </div>
                                {mailCodeError && <FormError message="Please enter your email verification code" />}
                                <div className="flex justify-center h-10 mt-8 mb-4">
                                    <Button
                                        variant="contained"
                                        onClick={() => { onSubmit('email') }}
                                        className="bg-blue-600 text-white rounded w-full max-w-xs"
                                        disabled={submitting}
                                    >
                                        submit
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                    <Modal open={tipsModal}>
                        <Box className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-lg rounded-lg p-2 w-full max-w-md">
                            <Grid container className="flex justify-between mt-1 mb-2">
                                <h2 className="text-xl font-semibold text-gray-700">Tips</h2>
                            </Grid>
                            <div className="container mx-auto p-4 text-slate-500 leading-7">
                                Congratulations! The phone verification in the two-step verification has been completed
                            </div>
                            <div className="flex justify-center h-10 mt-8 mb-4">
                                <Button
                                    onClick={() => { goUserCenter() }}
                                    className="bg-blue-600 text-white rounded w-full max-w-xs"
                                >
                                    Now View Account
                                </Button>
                            </div>
                        </Box>
                    </Modal>
                    <RollingTextLoading text={[""]} show={submitting} />
                </Box>
            </Modal>
        </>
    );
}

export default VerifyModal;
